import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { FC, useState, useMemo, useEffect, useCallback } from 'react'
import styles from 'components/features/coaching/advisorVideoCall/VideoCallPagePreset/VideoCallPagePreset.styl'
import moment from 'moment'
import { AgoraJoinChannelAction } from 'components/features/videoCalls/types/actions'


export const MeetingStartCountdown: FC = () => {
  const [cache, render] = useState({})
  const startTime = useStoreSelector((state) => state.data.advisors.videoCallDetails.details?.start_time ?? null)
  const { diff, remain } = useMemo(() => {
    if (!startTime) {
      return { diff: 0, remain: null }
    }

    const delta = moment(startTime).diff(moment())
    return {
      diff: delta,
      remain: moment.utc(delta).format('m:ss'),
    }
  }, [cache, startTime])

  useEffect(() => {
    const tmr = setTimeout(() => render({}), 1000)
    return () => {
      clearTimeout(tmr)
    }
  }, [cache])

  const connection = useStoreSelector((store) => store.data.advisors.videoCallDetails.details?.video?.connection ?? null)
  const clientState = useStoreSelector((store) => store.app.videoCall.client.state)
  const dispatch = useStoreDispatch()
  const handleJoin = useCallback(() => {
    if (!connection || clientState !== 'idle') {
      return
    }

    dispatch(new AgoraJoinChannelAction(connection))
  }, [connection, dispatch, clientState])

  if (remain === null) {
    return null
  }

  if (diff < 0) {
    return (
      <h2>
        The session has started.&nbsp;
        <br className={ styles.showOnMobile } />
        Please <a onClick={ handleJoin }>join</a> now.
      </h2>
    )
  }

  return (
    <h2>
      Session beggining in <b>{ remain }</b>
    </h2>
  )
}
